export const getActiveClass = (bool) => `${bool ? 'active' : ''}`;